<template>
  <div>
    <v-layout row wrap class="field" v-if="!isFile">
      <v-flex xs12 md3 class="field-left">
        <div class="status" :class="status.toLowerCase()">
          <div class="status-circle">
            <i class="material-icons status-icon">{{ statusIcon }}</i>
          </div>
        </div>
        <div class="field-heading" :class="status.toLowerCase()">
          {{ title }}
        </div>
      </v-flex>
      <v-flex xs12 md9>
        <slot></slot>
        <div v-if="error" class="field-error">{{ error }}</div>
        <div v-else class="field-instructions">{{ instructions }}</div>
        <div v-if="title == 'Amazon URL'">
          <div class="field-instructions-url-supported">
            &bull; &nbsp;<span class="field-instructions-url-supported-label"
              >Example URL: </span
            >
            <a
              rel="noopener noreferrer nofollow"
              target="_blank"
              href="https://www.amazon.com/Meditations-Marcus-Aurelius-ebook/dp/B08RYB957M/"
            >
              https://www.amazon.com/Meditations-Marcus-Aurelius-ebook/dp/B08RYB957M/</a
            >
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="field field-file" v-if="isFile">
      <v-flex xs12 md12 class="field-left">
        <div class="status" :class="status.toLowerCase()">
          <div class="status-circle">
            <i class="material-icons status-icon">{{ statusIcon }}</i>
          </div>
        </div>
        <div class="field-heading" :class="status.toLowerCase()">
          {{ title }}
        </div>
      </v-flex>
      <v-flex xs12 md12>
        <slot></slot>
        <div class="field-instructions">{{ instructions }}</div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
const statuses = {
  Pending: {
    icon: "",
  },
  Completed: {
    icon: "check",
  },
  Error: {
    icon: "",
  },
};

export default {
  props: ["title", "instructions", "status", "error", "isFile"],
  data: function () {
    return {};
  },
  computed: {
    statusIcon() {
      return statuses[this.status].icon;
    },
    statusClass() {
      return this.status.toLowerCase();
    },
  },
};
</script>

<style scoped>
.field {
  padding: 8px 0;
}
.field-file {
  padding: 8px 60px;
}

.field-left {
  padding-top: 10px;
}

.field-divider {
  width: 100%;
  height: 40px;
}

.field-heading {
  padding-top: 9px;
  font-size: 15pt;
  font-weight: 600;
  color: #2196f3;
}
.completed.field-heading {
  color: #4caf50 !important;
}

.field-instructions {
  color: #888;
  margin-top: -10px;
  padding-top: 0;
  padding-left: 0px;
  padding-right: 80px !important;
  font-size: 12pt;
}
.field-error {
  color: #ef5350;
  margin-top: -10px;
  padding-top: 0;
  padding-left: 0px;
  padding-right: 80px !important;
  font-size: 12pt;
}

.status {
  float: left;
  width: 32px;
  margin: 14px 1px 12px 9px;
}
.status-circle {
  background: #fbfbff;
  border: 3px solid #2196f3;
  border-radius: 32px;
  width: 21px;
  height: 21px;
}

.completed .status-icon {
  color: #fff;
  font-size: 11pt;
}
.completed .status-circle {
  background: #4caf50 !important;
  border: 3px solid #4caf50 !important;
}
.pending .status-icon {
  color: #fff;
  font-size: 11pt;
}
.pending .status-circle {
  background: #bbdefb !important;
  border: 3px solid #ddd #2196f3;
}
.error {
  background: #fff !important;
}
.error .status-icon {
  color: #fff;
  font-size: 11pt;
}
.error .status-circle {
  background: #bbdefb !important;
  border: 3px solid #ddd #2196f3;
}

.title-field {
  font-size: 17pt !important;
  border-bottom: 4px !important;
}

.field-instructions-url-supported {
  color: #888;
  padding: 0.25em 0 0 1em;
}

.field-instructions-url-supported-label {
  font-weight: 500;
  /* color: #111; */
}
</style>